export default __webpack_public_path__ + "static/media/hbs-cbb-poster-1.55087ec0.jpg";